import { GOOGLE_ADS } from './enums/google-ads-config';
import { useInitClarity } from './useInitClarity';
import initMetaPixel from './loadMetaPixel';

export function loadThirdPartyScripts() {
  onUserInteraction(function () {
    loadGoogleOptimize();
    useInitClarity();
    loadTwitterPixel();
    loadGoogleAnalyticsAndAds();
    loadHotjar();
    loadChatwoot();
    loadPendo();
    loadOneSignal();
    initMetaPixel(process.env.REACT_APP_FACEBOOK_PIXEL_ID);
  });
}

function onUserInteraction(callback) {
  var fired = false;

  function handler() {
    if (!fired) {
      fired = true;
      callback();
    }
  }

  ['scroll', 'mousemove', 'keydown', 'touchstart'].forEach(function (event) {
    window.addEventListener(event, handler, { once: true, passive: true });
  });
}

//// GOOGLE OPTIMIZE

function loadGoogleOptimize() {
  var script = document.createElement('script');
  script.src = 'https://www.googleoptimize.com/optimize.js?id=OPT-M3XH52P';
  script.async = true;
  document.head.appendChild(script);
}

///// Facebook Pixel

// function loadFacebookPixel() {
//   (function (f, b, e, v, n, t, s) {
//     if (f.fbq) return;

//     n = f.fbq = function () {
//       n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
//     };

//     if (!f._fbq) f._fbq = n;

//     n.push = n;
//     n.loaded = true;
//     n.version = '2.0';
//     n.queue = [];

//     t = b.createElement(e);
//     t.async = true;
//     t.src = v;

//     s = b.getElementsByTagName(e)[0];
//     s.parentNode.insertBefore(t, s);
//   })(
//     window,
//     document,
//     'script',
//     'https://connect.facebook.net/en_US/fbevents.js'
//   );

//   window.fbq('init', '3947774575496031');
//   window.fbq('track', 'PageView');
// }

////// Twitter Pixel

function loadTwitterPixel() {
  (function (e, t, n, s, u, a) {
    if (e.twq) return;

    s = e.twq = function () {
      s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);
    };

    s.version = '1.1';
    s.queue = [];

    u = t.createElement(n);
    u.async = true;
    u.src = 'https://static.ads-twitter.com/uwt.js';

    a = t.getElementsByTagName(n)[0];
    a.parentNode.insertBefore(u, a);
  })(window, document, 'script');

  window.twq('init', 'o8rx6');
  window.twq('track', 'PageView');
}

//// GOOGLE ANALYTICS & ADS
function loadGoogleAnalyticsAndAds() {
  var script = document.createElement('script');
  script.src =
    'https://www.googletagmanager.com/gtag/js?id=' +
    process.env.REACT_APP_GOOGLE_ANALYTICS_ID;
  script.async = true;
  document.head.appendChild(script);

  script.onload = function () {
    window.dataLayer = window.dataLayer || [];

    function gtag() {
      window.dataLayer.push(arguments);
    }

    window.gtag = gtag;

    gtag('js', new Date());
    gtag('config', process.env.REACT_APP_GOOGLE_ANALYTICS_ID);
    gtag('config', GOOGLE_ADS.CONVERSION_ID);
  };
}

//// HOTJAR

function loadHotjar() {
  (function (h, o, t, j, a, r) {
    h.hj =
      h.hj ||
      function () {
        (h.hj.q = h.hj.q || []).push(arguments);
      };

    h._hjSettings = { hjid: 3065707, hjsv: 6 };

    a = o.getElementsByTagName('head')[0];
    r = o.createElement('script');
    r.async = true;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
}

//// CHATWOOT

function loadChatwoot() {
  var BASE_URL = 'https://engage.myserviceagent.net';

  var script = document.createElement('script');
  script.src = BASE_URL + '/packs/js/sdk.js';
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);

  script.onload = function () {
    window.chatwootSDK.run({
      websiteToken: 'fEf3snSSq1vDbTJT5mdBgRA4',
      baseUrl: BASE_URL
    });
  };
}

//// PENDO

function loadPendo() {
  (function (apiKey) {
    (function (p, e, n, d, o) {
      var v, w, x, y, z;
      o = p[d] = p[d] || {};
      o._q = o._q || [];

      v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];

      for (w = 0, x = v.length; w < x; ++w) {
        (function (m) {
          o[m] =
            o[m] ||
            function () {
              o._q.push([m].concat([].slice.call(arguments)));
            };
        })(v[w]);
      }

      y = e.createElement(n);
      y.async = true;
      y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
      z = e.getElementsByTagName(n)[0];
      z.parentNode.insertBefore(y, z);
    })(window, document, 'script', 'pendo');
  })('91a4c872-bf27-4f26-4dd9-39f0a6d48eb7');
}

//// ONE SIGNAL

function loadOneSignal() {
  var script = document.createElement('script');
  script.src = 'https://cdn.onesignal.com/sdks/OneSignalSDK.js';
  script.defer = true;
  document.head.appendChild(script);

  script.onload = function () {
    window.OneSignal = window.OneSignal || [];

    window.OneSignal.push(function () {
      window.OneSignal.init({
        appId: '3a0c8562-f0bf-437f-9a7e-9cdca4e3d156'
      });
    });
  };
}
